import httpClient from '@/lib/httpClient'
import { useMutation } from '@tanstack/react-query'

/**
 * Fire-and-forget intent signal when a user opens a feature upgrade modal.
 * Never surfaces errors — the modal UX must not depend on this.
 */
export default function useFeatureInterest() {
  return useMutation({
    mutationFn: async (lookupKey: string) => {
      await httpClient.post('billing/feature-interest', { lookup_key: lookupKey })
    },
    onError: () => {
      // intentionally silent
    },
  })
}
